import { t } from "i18next";
import React from "react";
import { Modal } from "react-bootstrap";

const SorryModal = ({ show, onHide, sorry = false, ...props }) => {
  return (
    <div>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={onHide}
        className="all-modal changeNumber"
        {...props}
      >
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <dib className="content">
                <h1> {sorry ? t("details:addonDetails.sorry") : t("details:addonDetails.please")}</h1>
                <p>{sorry ? t("details:addonDetails.sorryInfo") : t("details:addonDetails.pleaseInfo")}</p>
              </dib>
            </div>
            <div className="col-12">
              <button className="btn-blue" onClick={onHide}>
                {t("browse-apps:paymentDetails.paymentMessage:ok")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SorryModal;
